module.exports = __webpack_public_path__ + "img/train-blue.1fe7c545.svg";